import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Mail, Copy, Check } from 'lucide-react';
import api from '../lib/api';

export default function CheckEmail() {
  const [sp] = useSearchParams();
  const email = sp.get('email') || '';
  const [link, setLink] = useState('');
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchLink = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/dev/verify-link?email=${encodeURIComponent(email)}`);
      setLink(data.link || '');
    } catch {
      setLink('');
    } finally {
      setLoading(false);
    }
  };

  const copy = async () => {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };

  return (
    <div data-testid="check-email-page" className="max-w-md mx-auto px-4 sm:px-6 py-16 text-center">
      <div className="card-embossed p-10">
        <Mail className="mx-auto text-[#D4AF37]" size={40} />
        <h1 className="mt-4 font-serif-display text-3xl font-black text-gold-gradient">Check your email</h1>
        <p className="mt-3 text-[#C0C0C0]">
          We sent a verification link to <span className="text-[#D4AF37]">{email}</span>. Click it to activate your account.
        </p>

        <div className="mt-8 border-t border-[#D4AF37]/15 pt-6 text-left">
          <p className="text-xs uppercase tracking-[0.24em] text-[#C0C0C0]/80 mb-3">Dev shortcut</p>
          <p className="text-xs text-[#C0C0C0]/70 mb-3">
            Email delivery isn't wired up yet. Fetch your verification link directly:
          </p>
          <button
            data-testid="fetch-verify-link"
            onClick={fetchLink}
            disabled={loading || !email}
            className="btn-ghost-gold text-sm !py-2 !px-4"
          >
            {loading ? 'Fetching…' : 'Fetch verification link'}
          </button>
          {link && (
            <div className="mt-4">
              <div className="flex items-center gap-2 rounded-lg bg-[#0a0a0a] border border-[#D4AF37]/30 px-3 py-2">
                <code data-testid="verify-link-value" className="text-xs text-[#D4AF37] break-all">{link}</code>
                <button
                  onClick={copy}
                  className="text-[#C0C0C0] hover:text-[#D4AF37]"
                  aria-label="Copy link"
                >
                  {copied ? <Check size={16} /> : <Copy size={16} />}
                </button>
              </div>
              <a
                href={link}
                data-testid="verify-link-open"
                className="mt-3 inline-block text-sm text-[#D4AF37] underline"
              >
                Open verification link →
              </a>
            </div>
          )}
        </div>

        <Link to="/login" className="mt-8 inline-block text-sm text-[#C0C0C0] hover:text-[#D4AF37]">
          Back to login
        </Link>
      </div>
    </div>
  );
}
